import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  CCreateElement,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  CSidebarNavDropdown,
  CSidebarNavItem,
} from '@coreui/react';

// sidebar nav config
import navigation from './_nav';
import logo from '../assets/images/logo.png';

const TheSidebar = () => {
  const dispatch = useDispatch();
  const show = useSelector((state) => state.sidebarShow);
  const user = useSelector((state) => state.cognitoUser);

  return (
    <>
      <CSidebar show={show} onShowChange={(val) => dispatch({ type: 'set', sidebarShow: val })}>
        <CSidebarBrand className="d-md-down-none sed-om-sidebar-brand">
          <div className="sed-om-sidebar-logo-wrapper">
            <div className="logo">
              <img src={logo} alt="自然電力" />
            </div>
            <p className="site">認証基盤管理システム</p>
            {user && user.attributes && user.attributes.email && (
              <p className="name">{user.attributes['email']}</p>
            )}
          </div>
        </CSidebarBrand>
        <CSidebarNav>
          <CCreateElement
            items={navigation}
            components={{
              CSidebarNavDivider,
              CSidebarNavDropdown,
              CSidebarNavItem,
              CSidebarNavTitle,
            }}
          />
        </CSidebarNav>
      </CSidebar>
    </>
  );
};

export default React.memo(TheSidebar);
